var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.179,
    height: 25.179,
    viewBox: "0 0 25.179 25.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.589,64.417H.39a.39.39,0,0,1-.39-.39V49.39A.39.39,0,0,1,.39,49h4.7a.39.39,0,0,1,.39.39v4.1H9.758a.39.39,0,0,1,.39.39v4.293h4.684V53.879a.39.39,0,0,1,.39-.39h4.293v-4.1a.39.39,0,0,1,.39-.39h4.684a.39.39,0,0,1,.39.39V64.027A.39.39,0,0,1,24.589,64.417ZM.781,63.636H24.2V49.781H20.3v4.1a.39.39,0,0,1-.39.39H15.612v4.293a.39.39,0,0,1-.39.39H9.758a.39.39,0,0,1-.39-.39V54.269H5.09a.39.39,0,0,1-.39-.39v-4.1H.781Z",
    transform: "translate(0 -39.438)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.538,10.148H29.074a.39.39,0,0,1-.39-.39V5.464H24.39a.39.39,0,0,1-.39-.39V.39A.39.39,0,0,1,24.39,0H39.222a.39.39,0,0,1,.39.39V5.074a.39.39,0,0,1-.39.39H34.929V9.758A.39.39,0,0,1,34.538,10.148Zm-5.074-.781h4.684V5.074a.39.39,0,0,1,.39-.39h4.293V.781H24.781v3.9h4.293a.39.39,0,0,1,.39.39Z",
    transform: "translate(-19.316 0)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.19b87076.svg";
export { ForwardRef as ReactComponent };